import axios from 'axios'
// import { Message } from 'element-ui'
import { baseUrl, wxUrl } from '../config/config_dev'
import router from '../router'
import store from '../store'

// axios 拦截器
// axios.defaults.withCredentials = true

axios.interceptors.request.use(
  config => {
    console.log('request success')
    return config
  },
  error => {
    // Message.error(error.message)
    console.log('request fail')
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    console.log('response success')
    return response
  },
  error => {
    console.log('response fail')
    // Message.error(error.message)
    if (error.response && error.response.status === 401) {
      if (process.env.VUE_APP_BUILD_MODE === 'FHZ_WEB') {
        window.parent.postMessage({ type: 'user_logout' }, '*')
      } else {
        store.dispatch('account/reset')
        router.push(`/login`)
      }
    }
    return Promise.reject(error)
  }
)

const commonHeaders = {}
/**
 * @param {*} api 接口路径
 * @param {*} options 请求参数
 * @param {*} auth 是否token
 * @param {*} file 是否文件
 * @param {*} download 是否下载
 */
export const request = (
  api,
  options = {},
  auth = true,
  file = false,
  download = false
) => {
  const userInfo = store.state.account.userInfo

  const authHeader = auth ? { token: userInfo.token } : {}

  const fileHeader = file ? { 'Content-Type': 'multipart/form-data' } : {}

  const responseType = download ? { responseType: 'blob' } : {}

  return axios.post(baseUrl + api, options, {
    headers: {
      ...commonHeaders,
      ...authHeader,
      ...fileHeader
    },
    ...responseType
  })
}
export const request3 = (
  api,
  options = {},
  auth = true,
  file = false,
  download = false
) => {
  const userInfo = store.state.account.userInfo

  const authHeader = auth ? { token: userInfo.token } : {}

  const fileHeader = file ? { 'Content-Type': 'multipart/form-data' } : {}

  const responseType = download ? { responseType: 'blob' } : {}

  return axios.post(wxUrl + api, options, {
    headers: {
      ...commonHeaders,
      ...authHeader,
      ...fileHeader
    },
    ...responseType
  })
}
export const request2 = (
  api,
  auth = true,
  file = false,
  download = false
) => {
  const userInfo = store.state.account.userInfo

  const authHeader = auth ? { token: userInfo.token } : {}

  const fileHeader = file ? { 'Content-Type': 'multipart/form-data' } : { 'Content-Type': 'application/x-www-form-urlencoded' }

  const responseType = download ? { responseType: 'blob' } : {}

  return axios.get(baseUrl + api, {
    headers: {
      ...commonHeaders,
      ...authHeader,
      ...fileHeader
    },
    ...responseType
  })
}
export const request1 = (
  api,
  options = {},
  auth = true,
  file = false,
  download = false
) => {
  const userInfo = store.state.account.userInfo

  const authHeader = auth ? { token: userInfo.token } : {}

  const fileHeader = file ? { 'Content-Type': 'multipart/form-data' } : {}

  const responseType = download ? { responseType: 'blob' } : {}

  return axios.post(api, options, {
    headers: {
      ...commonHeaders,
      ...authHeader,
      ...fileHeader
    },
    ...responseType
  })
}
